export const fixedRoutes = [
  '/questionnaires/',
];
